var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"min-width":_vm.size,"width":_vm.size,"height":_vm.size,"large":"","color":"white"}},[_c('v-img',{attrs:{"width":_vm.size,"height":_vm.size,"src":_vm.getAvatarUrl(_vm.email || _vm.$store.state.home.user.email, _vm.size)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }